import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../../_models/garantias-idoneas';
import {NavService} from '../../../_services/_nav.service';
import {ActividadEconomica} from '../../../_models/actividad-economica';
import {GarantiasIdoneasActividades} from '../../../_models/garantias-idoneas-actividades';
import {ActividadEconomicaService} from '../../../_services/actividad-economica.service';
import {GarantiaIdoneasActividadesService} from '../../../_services/garantia-idoneas-actividades.service';
import {FormGroup} from '@angular/forms';
import { TipoActividadEconomica } from '../../../_enums/enum';

@Component( {
  selector: 'app-garantia-idoneas-actividades',
  templateUrl: 'garantia-idoneas-actividades.component.html'
} )

export class GarantiaIdoneasActividadesComponent implements OnInit {

  formulario: FormGroup;
  /** items */
  @Input() garantia: GarantiasIdoneas;

  actFuente: ActividadEconomica[] = [];
  actSeleccionadas: ActividadEconomica[] = [];
  listaGarantiasIdoneasActividades: GarantiasIdoneasActividades[] = [];
  allActividades: ActividadEconomica[] = [];
  carInformacionInicial = true;
  guardando = false;
  tipoActividad = TipoActividadEconomica;

  constructor(
    private actividadEconomicaServicio: ActividadEconomicaService,
    private navServicio: NavService,
    private garantiasActividades: GarantiaIdoneasActividadesService
  ) { }

  ngOnInit() {
    if ( this.garantia && (this.garantia.idGarantiaIdonea !== null && this.garantia.idGarantiaIdonea !== undefined && this.garantia.idGarantiaIdonea !== '') ) {
      /** Se carga garantias Servicios */
      forkJoin(
        this.garantiasActividades.listadoPorActividades( this.garantia.idGarantiaIdonea ),
        this.actividadEconomicaServicio.listarPorTipo( this.tipoActividad.CLASE )
      ).subscribe( ( [ garantiaActividades, actividades ] ) => {
        this.listaGarantiasIdoneasActividades = garantiaActividades;
        this.allActividades = actividades;
        this.cargarInformacionInicial();
      } );
    } else {
      forkJoin(
        this.actividadEconomicaServicio.listarPorTipo( this.tipoActividad.CLASE )
      ).subscribe( ( [  actividades ] ) => {
        this.allActividades = actividades;
        this.cargarInformacionInicial();
      } );
    }
  }

  cargarInformacionInicial() {
    this.allActividades.map( ae => {
      if ( this.listaGarantiasIdoneasActividades.find( sa => sa.
        idActividadEconomica === ae.idActividadEconomica && sa.indicadorHabilitado ) ) {
        this.actSeleccionadas.push( ae );
      } else {
        if ( ae.indicadorHabilitado ) {
          this.actFuente.push( ae );
        }
      }
    } );
    this.carInformacionInicial = false;
  }

  guardar( event: ActividadEconomica[], seleccionado: boolean ) {
    this.guardando = true;
    const registros = [];
    event.map( e => {
      const a = this.listaGarantiasIdoneasActividades
        .findIndex( sa => sa.idActividadEconomica === e.idActividadEconomica );
      const temp: GarantiasIdoneasActividades = {
        id: a >= 0 ? this.listaGarantiasIdoneasActividades[ a ].id : null,
        idGarantiaIdoneaActividadEconomica: a >= 0 ? this.listaGarantiasIdoneasActividades[ a ].idGarantiaIdoneaActividadEconomica : null,
        idGarantiaIdonea: this.garantia.idGarantiaIdonea,
        idActividadEconomica: e.idActividadEconomica,
        actividadEconomica: e.actividadEconomica,
        indicadorHabilitado: seleccionado,
        auditoriaUsuario: null,
        auditoriaFecha: null
      };
      if ( a >= 0 ) {
        this.listaGarantiasIdoneasActividades[ a ].indicadorHabilitado = seleccionado;
      } else {
        this.listaGarantiasIdoneasActividades.push( temp );
      }
      registros.push( temp );
    } );
    this.garantiasActividades.bulk( registros ).subscribe( res => {
      if ( seleccionado ) {
        res.map( ( s: GarantiasIdoneasActividades ) => {
          const a = this.listaGarantiasIdoneasActividades.
          findIndex( x => x.idActividadEconomica === s.idActividadEconomica && !x.idGarantiaIdoneaActividadEconomica );
          if ( a >= 0 ) {
            this.listaGarantiasIdoneasActividades[ a ].idGarantiaIdoneaActividadEconomica = s.idGarantiaIdoneaActividadEconomica;
          }
        } );
      }
      this.navServicio.setMesage( 2 );
      this.guardando = false;
    } );
  }


  }
